import { wrapper } from 'src/redux/store'
import {
  getLineNews,
  getRemoteMapData,
  populateFilterStore,
} from 'src/redux/thunks'
import { ENTITY } from 'src/consts'
import Coin from 'src/pages/Coin'

const CoinsTable = props => <Coin {...props} />

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ query }) => {
      await store.dispatch(
        populateFilterStore({ ...query, ranking: 'all' }, ENTITY.COIN)
      )
      await store.dispatch(getLineNews(process.env.NEXT_PUBLIC_API_ENDPOINT))
      await store.dispatch(
        getRemoteMapData({
          entity: ENTITY.COIN,
          url: process.env.NEXT_PUBLIC_API_ENDPOINT,
        })
      )
    }
)

export default CoinsTable
